<!-- HTML -->
<template>
  <pl-dialog
    :header="'Oops!'"
    :headerStyle="'font-weight: bold; font-size: 24px'"
    :maxWidth="'600px'"
    :padding="'20px'"
  >
    <pl-button
      @click.native="handleModalClose"
      style="position: absolute; right: 0; top: 0;"
      class="pl-icon"
    >
      <i class="fa fa-close fa-lg"></i>
    </pl-button>
    <div class="center-xs">
      <div class="mt3 pl-subheading">
        Your school needs to purchase additional teacher licenses to upgrade
        your account. Please contact one of the Parlay administrators from your
        school.
      </div>
      <div v-if="adminUsersOfSchool.length" class="mt4 admin-users">
        <div v-for="user in adminUsersOfSchool" :key="user.name">
          {{ user.name }} - {{ user.email }}
        </div>
      </div>
      <div class="mt4">
        <pl-button
          @click.native="handleModalClose"
          class="pl-primary"
          style="font-size: 16px; padding: 6px 18px;"
        >
          Okay, got it!
        </pl-button>
      </div>
    </div>
  </pl-dialog>
</template>

<!-- JS -->
<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      adminUsersOfSchool: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      ...mapGetters([]),
    },
    methods: {
      handleModalClose() {
        localStorage.removeItem('showBlockUpgradeModal');
        this.$emit('closeModal');
      },
    },
  };
</script>

<!-- CSS -->
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .admin-users {
    font-size: 16px
    font-weight: 600
    letter-spacing: 0.01em
    line-height: 24px
  }
</style>



// WEBPACK FOOTER //
// upgradeBlockModal.vue?12c3f89c